
<template>
    <!-- template="checkout/shipping/addressTiles" -->
    <!-- ! <ShippingAdressTiles /> -->
    <template v-for="address in Addresses" :key="currentStage + address.UUID">
        <div :class="`address-card-container ${isSelectedAddress(address) === true ? 'selected' : ''}`"
            :data-address-id="address.ID || ''" :data-first-name="address.firstName || ''"
            :data-last-name="address.lastName || ''" :data-address1="address.address1 || ''"
            :data-address2="address.address2 || ''" :data-city="address.city || ''"
            :data-state-code="address.stateCode || ''" :data-country-code="address.countryCode.value || ''"
            :data-postal-code="address.postalCode" :data-area-code="address.areaCode" :data-phone="address.phone"
            data-is-gift="" data-gift-message="">
            <input v-if="isCheckoutScope" type="radio" class="form-check-input addressSelector" :id="`${address.UUID}`" name="dummy"
                :checked="isSelectedAddress(address) === true ? true : null" :value="'ab_' + address.ID"
                @click="selectAddress($event.target.value, address)" />
            <component :is="isCheckoutScope ? 'label' : 'div'" class="form-check-label" :for="address.UUID">
                <div class="address-card">
                    <div class="address-card-front">
                        <div v-if="!isCheckoutScope" class="row pt-1">
                            <h6 class="col-10 px-3 pt-2 mt-1 address-heading text-uppercase" data-cs-mask>{{ address.ID }}</h6>
                            <div tabindex="0" role="button" :aria-current="isSelectedAddress(address)" :aria-label="address.ID"
                                :class="`address-selector-checkbox ml-auto mt-1 mr-2 ${isSelectedAddress(address) ? 'icon-notifications-checkmark' : ''}`" 
                                @click="selectAddress($event.target.value, address)"
                            ></div>
                        </div>
                        <div class="address-card-body text-break">
                            <div class="customer-name" data-cs-mask>
                                {{ address.firstName || '' }} {{
                                    address.lastName
                                }}
                            </div>
                            <div class='address1' data-cs-mask>
                                {{ address.address1 }}</div>
                            <div class='address2' data-cs-mask>
                                {{ address.address2 || '' }}</div>
                            <div class='city-state-postal' data-cs-mask>
                                {{ (address.city || '') + (address.stateCode ? `, ${address.stateCode}` : '') + (address.postalCode ? `, ${address.postalCode}` : '') }}
                            </div>
                            <div class="country" data-cs-mask>
                                {{ address.countryCode.displayValue }}</div>
                            <div v-if="address.phone" data-cs-mask>
                                <span class="body-alt" v-html="$t('label.addressbook.phone')"></span>
                                <span class="phone">
                                    {{ formatPhoneNumber(address.phone, address.areaCode ?
                                        pdict.phoneCountryCodeMap[address.areaCode] : (address.countryCode ?
                                            address.countryCode.value : '')).national }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span v-if="isCheckoutScope" v-html="$t('label.editaddress')"></span>
            </component>
            <span v-if="isCheckoutScope" class="btn btn-link btn-show-details" v-html="$t('action.edit.address')" :aria-label="$t('label.editaddress')"
                @click="enterEditMode($event)" @keydown.enter.space.prevent="enterEditMode($event)" role="button" tabindex="0" :aria-describedby="`${address.UUID}`"></span>
            <div v-if="isSelectedAddress(address) && dataAddressMode === 'details'" class="shipping-address-block">
                <ShippingForm v-if="FormName === 'shipping'" />
                <BillingForm v-else />
            </div>
        </div>
    </template>
    <div v-if="isCheckoutScope" :class="`address-card-container ${getSelectedAddress() ? '' : 'selected'} new-address`" data-address-id
        data-first-name data-last-name data-address1 data-address2 data-city data-state-code data-country-code
        data-postal-code data-gift-message data-is-gift data-phone>
        <input type="radio" class="form-check-input addressSelector" :id="`new-address`" name="dummy" value="new"
            :checked="getSelectedAddress() ? null : true" @click="selectAddress($event.target.value)" />
        <label class="form-check-label" for="new-address">
            <div v-html="$t('action.add.newaddress')">
            </div>
        </label>

        <div v-if="dataAddressMode !== 'details'" class="shipping-address-block" v-show="dataAddressMode === 'new'">
            <ShippingForm v-if="FormName === 'shipping'" />
            <BillingForm v-else />
        </div>
    </div>
    <!-- ! <ShippingAdressTiles > -->
</template>
    
<script setup>
import { defineProps, computed, watch, nextTick } from 'vue';
import { mapGetters, mapMutations, mapActions } from "@/store/helper/vuex";
import { formatPhoneNumber } from "@/components/helper/util"
import BillingForm from '@/components/checkout/BillingForm'
import ShippingForm from '@/components/checkout/ShippingForm'

import { EventBus as oldEventBus } from "@/scripts/event-bus.js";

const props = defineProps({
    Addresses: Array,
    FormName: String
})

const { checkout, shippingVars, billingVars, formFields, currentStage, vueVariables, lastFormData, shippingDynamicStructure, billingDynamicStructure, billingLocale, shippingLocale } = mapGetters();
const { setShippingVars, setBillingVars, clearFieldErrors } = mapMutations();
const { updateFormField } = mapActions();

const pdict = checkout || mapGetters().pdict;

const isCheckoutScope = computed(() => { return props.FormName !== "SOR" })

const shippingModel = computed(() => { return pdict.value.order ? pdict.value.order.shipping[0] : null });

const selectedShippingAddressUUID = computed(() => { return shippingVars.value.selectedAddressUUID });
const selectedBillingAddressUUID = computed(() => { return billingVars.value.selectedAddressUUID });

const dataAddressMode = computed(() => { return currentStage.value === 'shipping' ? (shippingVars.value.dataAddressMode ? shippingVars.value.dataAddressMode : null) : (billingVars.value.dataAddressMode ? billingVars.value.dataAddressMode : null) });

const getSelectedAddress = () => {
    switch (currentStage.value) {
        case 'shipping':
            return selectedShippingAddressUUID.value;
        case 'payment':
            return selectedBillingAddressUUID.value;
        case 'billing':
            return selectedBillingAddressUUID.value;
    }
};

const isSelectedAddress = (address) => {
    let selectedAddressUUID = getSelectedAddress();
    return address.UUID === selectedAddressUUID;
};

const setCommonVars = ({ fieldName, fieldValue }) => {
    switch (currentStage.value) {
        case 'shipping':
            setShippingVars({ fieldName, fieldValue });
            break;
        case 'payment':
            setBillingVars({ fieldName, fieldValue });
            break;
    }
};

const enterEditMode = (event) => {
    let addressInputElement = event.target.parentElement.firstChild;
    let addressUUID = addressInputElement.id;
    let address = props.Addresses.find((address) => addressUUID.includes(address.UUID));

    if (getSelectedAddress() !== address.UUID) {
        let targetValue = addressInputElement.value;
        selectAddress(targetValue, address);

    }
    setCommonVars({ fieldName: 'dataAddressMode', fieldValue: 'details' });

    oldEventBus.$emit('phoneValidationPhoneBlur');
};


const updateFormFieldsInCommon = ({ address, formName }) => {
    if (address) {
        for (const [key, value] of Object.entries(formFields.value[formName])) {
            if (key !== 'email') { // Email is not part of the address. See AddressTiles.vue instances.
                if (formName === 'billing' && address.countryCode.value === 'HK' && (key === 'HKCity' || key === 'city')) {
                    updateFormField({
                        formName: formName,
                        fieldName: 'HKCity',
                        fieldValue: address['city'] || ''
                    });
                } else {
                    updateFormField({
                        formName: formName,
                        fieldName: key,
                        fieldValue: key === 'country' ? address['countryCode'].value : address[key] || ''
                    });
                }
            }
        }
    } else {
        oldEventBus.$emit('clearFormFields', { formName: formName, currentDynamicStructure: formName === 'shipping' ? shippingDynamicStructure.value[shippingLocale.value] : billingDynamicStructure.value[billingLocale.value] })
    }
}

const selectAddress = (addressUUID, address) => {
    if (currentStage.value === 'shipping') {
        clearFieldErrors({ formName: 'shipping' });
        setShippingVars({ fieldName: 'selectedAddressUUID', fieldValue: address && address.UUID || null });
        updateFormFieldsInCommon({ address, formName: 'shipping' });
        if (isCheckoutScope.value) {
            setShippingVars({ fieldName: 'dataAddressMode', fieldValue: addressUUID === 'new' ? 'new' : 'customer' });
            nextTick(() => {
                oldEventBus.$emit('updateShippingMethodDynamicFields');
            });
        }
    } else {
        clearFieldErrors({ formName: 'billing' });
        setBillingVars({ fieldName: 'selectedAddressUUID', fieldValue: address && address.UUID || null });
        updateFormFieldsInCommon({ address, formName: 'billing' })
        if (isCheckoutScope.value) {
            setBillingVars({ fieldName: 'dataAddressMode', fieldValue: addressUUID === 'new' ? 'new' : 'customer' });
        }
    }
}

const refreshBillingSelectedAddress = () => {
    if (selectedShippingAddressUUID.value === selectedBillingAddressUUID.value) {
        updateFormFieldsInCommon({ address: props.Addresses.find((address) => selectedBillingAddressUUID.value === address.UUID), formName: 'billing' })
    }
}

if (props.FormName === 'shipping') {
    oldEventBus.$on('refreshBillingSelectedAddress', () => {
        refreshBillingSelectedAddress();
    });
}

oldEventBus.$on('updateFormFieldsInCommon', (data) => {
    updateFormFieldsInCommon(data);
});

const refreshBillingDataAddressMode = () => {
    setBillingVars({ fieldName: 'dataAddressMode', fieldValue: selectedBillingAddressUUID.value ? 'customer' : 'new' });
}

const refreshShippingDataAddressMode = () => {
    setShippingVars({ fieldName: 'dataAddressMode', fieldValue: shippingModel.value.matchingAddressId && getSelectedAddress() ? 'customer' : 'new' });
}

const isCustomerAuthenticated = computed(() => { return vueVariables.value.isCustomerAuthenticated });

const updateSelectedShippingBillingAddressOnLogin = watch(isCustomerAuthenticated, (newValue) => {
    if (newValue === true) {
        const selectedShippingAddress = props.Addresses.find((address) => address.UUID === selectedShippingAddressUUID.value);
        const selectedBillingAddress = props.Addresses.find((address) => address.UUID === selectedBillingAddressUUID.value);

        if (selectedBillingAddress) {
            updateFormFieldsInCommon({ address: selectedBillingAddress, formName: 'billing' });
        }

        if (selectedShippingAddress) {
            updateFormFieldsInCommon({ address: selectedShippingAddress, formName: 'shipping' });
            updateFormField({
                formName: 'shipping',
                fieldName: 'email',
                fieldValue: lastFormData.value['shipping'].email.value
            });
        }
    }
}, {
    flush: 'post'
});

oldEventBus.$on('refreshAddressTiles', () => {
    setShippingVars({ fieldName: 'selectedAddressUUID', fieldValue: pdict.value.addressInShipment || null });
    setBillingVars({ fieldName: 'selectedAddressUUID', fieldValue: pdict.value.billingAddressUUID || null });
    refreshShippingDataAddressMode();
    refreshBillingDataAddressMode();
});

// Actual Setup Calls
if (isCheckoutScope.value) {
    refreshShippingDataAddressMode();
    refreshBillingDataAddressMode();
}
</script>